import React, {
  createContext,
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useState,
} from 'react';
import { useSelector } from 'react-redux';
import { Row } from '@vertem-core/vertice-ds';
import MediaQuery from 'react-responsive';
import 'Assets/styles/default/components/Loading/index.less'
import Lottie from 'react-lottie';
import LoadingAnimation from 'Assets/animations/loading.json';

const RootLoading = createContext({
  isLoaded: true,
});

export const useRootLoading = () => useContext(RootLoading);

export const RootLoadingAnimation = () => {
  const options = {
    loop: true,
    autoplay: true,
    animationData: LoadingAnimation,
  };

  return (
    <Row
      justify="center"
      align={'middle'}
      className="root-loading-main"
    >
      <MediaQuery minWidth={769}>
        <Lottie
          options={options}
          height={400}
          width={400}
          isClickToPauseDisabled
        />
      </MediaQuery>
      <MediaQuery maxWidth={768}>
        <Lottie
          options={options}
          height={300}
          width={300}
          isClickToPauseDisabled
        />
      </MediaQuery>
    </Row>
  );
};

const Provider = ({ children, callback }) => {
  const [isLoaded, setIsLoaded] = useState(false);

  const handleSetIsloading = useCallback(
    (status) => {
      setIsLoaded(status);
    },
    [isLoaded]
  );

  const value = useMemo(
    () => ({
      setIsLoaded: handleSetIsloading,
      isLoaded,
    }),
    [handleSetIsloading, isLoaded]
  );

  useEffect(() => {
    if (!isLoaded) {
      document.querySelector('body').style.overflow = 'hidden';
    } else {
      callback();
      document.querySelector('body').style.overflow = 'initial';
    }
  }, [isLoaded]);

  return <RootLoading.Provider value={value}>{children}</RootLoading.Provider>;
};

const RootProvide = ({ children }) => {
  const isLoading = useSelector((state) => state.Loading);

  const [isLoaded, setIsLoaded] = useState(false);
  return (
    <>
      {isLoading && <RootLoadingAnimation />}

        {children}
    </>
  );
};

export default RootProvide;
